import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { PedidoViewPage } from '../pedido-view/pedido-view';
import { ViewProvider } from '../../providers/view/view';

@Component({
  selector: 'page-pedido-list',
  templateUrl: 'pedido-list.html',
})
export class PedidoListPage {

  pedidos: Array<any>;
 
  constructor(public navCtrl: NavController, public navParams: NavParams,  public server: SemovelProvider, private view:ViewProvider) {
  }

  ionViewDidLoad() {
    this.pedidos = [];
    
    let request = { method: 'pedido/list', params: [] };

    this.server.postData(request, {}).subscribe(data => {
      if (data) 
        this.loadList(data);
        return true;
    },
    error => { this.server.showError(error); }          
    );
  }

  visualizar_pedido(pedido) {
    this.server.postData({method:"pedido/view/"+pedido.id}).subscribe(
      (pedidoServer) => {
        this.navCtrl.push(PedidoViewPage, {pedido:pedidoServer});
      },
      (erro) => {
        this.view.showMessage("Não foi possível carregar o pedido. "+erro);
      }
    );
  }
 
  loadList(data) {
    this.pedidos = [];
    
    for(var i in data) {       
      this.pedidos.push(data[i]);
    }
  }

  getCor(pedido){
    if(pedido && pedido.cancelado){
      return "danger";
    }
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/pages/pedido-list/pedido-list.ts